<template>
  <div>
    <form class="w-100" @submit.prevent="submit">
      <div class="row">
        <div class="col-12 text-left">
          <!-- <button
            v-if="id !== 'new'"
            @click="deleteBook"
            type="button"
            class="btn btn-danger"
          >
            حذف کتاب
            <i class="fas fa-trash" />
          </button> -->
          <button type="submit" class="btn btn-success mr-2">
            <span v-if="id !== 'new'">
              به روزرسانی کتاب
              <i class="far fa-save" />
            </span>
            <span v-else>
              ذخیره کتاب جدید
              <i class="fas fa-plus" />
            </span>
          </button>

          <hr />
        </div>
        <div
          v-if="id === 'new' || (id !== 'new' && Object.keys(item).length)"
          class="col-12"
        >
          <div class="row">
            <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
              <StatsCard>
                <div class="icon-big text-center icon-info" slot="header">
                  <i class="far fa-thumbs-up" />
                </div>
                <div class="numbers" slot="content">
                  <p>تعداد لایک ها</p>
                  {{ item.totalLikesCount || "---" }}
                </div>
              </StatsCard>
            </div>
            <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
              <StatsCard>
                <div class="icon-big text-center icon-info" slot="header">
                  <i class="far fa-eye" />
                </div>
                <div class="numbers" slot="content">
                  <p>تعداد بازدید ها</p>
                  {{ item.totalViewsCount || "---" }}
                </div>
              </StatsCard>
            </div>
            <div class="col-12">
              <card class="card" title="اطلاعات پایه">
                <div>
                  <div class="form-row">
                    <div class="col-12 col-lg-4 mb-3">
                      <div class="form-group text-right">
                        <label for="title">عنوان</label>
                        <input
                          id="title"
                          type="text"
                          class="form-control"
                          placeholder="عنوان"
                          v-model="item.title"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-lg-4 mb-3">
                      <div class="form-group text-right">
                        <label for="price">قیمت به ریال</label>
                        <input
                          id="price"
                          type="text"
                          class="form-control"
                          placeholder="مثلا 10000 "
                          v-model="item.price"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-lg-4 mb-3">
                      <div class="form-group text-right">
                        <label for="euroPrice">قیمت به یورو</label>
                        <input
                          dir="rtl"
                          id="euroPrice"
                          type="text"
                          class="form-control"
                          placeholder="مثلا 5"
                          v-model="item.euroPrice"
                        />
                      </div>
                    </div>

                    <div class="col-12 col-lg-4 mb-3">
                      <div class="form-group text-right">
                        <label for="authors"> نویسنده </label>
                        <input
                          dir="rtl"
                          id="authors"
                          type="text"
                          class="form-control"
                          placeholder=" نویسنده"
                          v-model="item.authors"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-lg-4 mb-3">
                      <div class="form-group text-right">
                        <label for="narrators"> گوینده </label>
                        <input
                          dir="rtl"
                          id="narrators"
                          type="text"
                          class="form-control"
                          placeholder=" گوینده"
                          v-model="item.narrators"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-lg-4 mb-3">
                      <div class="form-group text-right">
                        <label for="publication"> ناشر </label>
                        <input
                          dir="rtl"
                          id="publication"
                          type="text"
                          class="form-control"
                          placeholder=" ناشر"
                          v-model="item.publication"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-lg-4 mb-3">
                      <div class="form-group text-right">
                        <label for="illustrators"> تصویرگر </label>
                        <input
                          dir="rtl"
                          id="illustrators"
                          type="text"
                          class="form-control"
                          placeholder=" تصویرگر"
                          v-model="item.illustrators"
                        />
                      </div>
                    </div>
                    <!-- <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="authors">نویسنده </label>
                      <appDatePicker
                        id="authors"
                        placeholder="نویسنده "
                        v-model="item.authors"
                  :multiple="true"
                      />
                    </div>
                  </div> -->
                    <!-- <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="authors">نویسنده </label>
                      <appDatePicker
                        id="authors"
                        placeholder="نویسنده "
                        v-model="item.authors"
                        :multiple="true"
                      />
                    </div>
                  </div> -->
                    <!-- <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="authors">نویسنده </label>
                      <appDatePicker
                        id="authors"
                        placeholder="نویسنده "
                        v-model="item.authors"
                        :multiple="true"
                      />
                    </div>
                  </div> -->
                    <!-- <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="authors">نویسنده </label>
                      <appDatePicker
                        id="authors"
                        placeholder="نویسنده "
                        v-model="item.authors"
                        :multiple="true"
                      />
                    </div>
                  </div> -->
                    <!-- 
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="categories">دسته بندی</label>
                      <appCategorySelect
                        id="categories"
                        placeholder="دسته بندی"
                        v-model="item.category_ids"
                        :multiple="true"
                      />
                    </div>
                  </div> -->
                    <!-- <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="minAge">حداقل سن</label>
                      <input
                        id="minAge"
                        type="number"
                        class="form-control"
                        placeholder="حداقل سن"
                        v-model.number="item.min_age"
                      />
                    </div>
                  </div> -->
                    <!-- <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="maxAge">حداکثر سن</label>
                      <input
                        id="maxAge"
                        type="number"
                        class="form-control"
                        placeholder="حداکثر سن"
                        v-model.number="item.max_age"
                      />
                    </div>
                  </div> -->
                    <div class="col-12 col-lg-4 mb-3">
                      <div class="form-group text-right">
                        <label for="order">ترتیب</label>
                        <input
                          id="order"
                          type="number"
                          class="form-control"
                          placeholder="ترتیب"
                          v-model.number="item.order"
                        />
                      </div>
                    </div>
                    <!-- <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="genders">جنسیت</label>
                      <appGendersSelect
                        id="genders"
                        placeholder="جنسیت"
                        v-model="item.genders"
                        :multiple="true"
                      />
                    </div>
                  </div> -->
                    <!-- <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="isSpecial">ویژه</label>
                      <fv-switch
                        id="isSpecial"
                        class="form-control d-block"
                        placeholder="ویژه"
                        v-model="item.is_special"
                      />
                    </div>
                  </div> -->
                    <div class="col-12 col-lg-4 mb-3">
                      <div class="form-group text-right">
                        <label for="enable">فعال</label>
                        <fv-switch
                          id="enable"
                          class="form-control d-block"
                          placeholder="فعال"
                          v-model="item.enabled"
                        />
                      </div>
                    </div>
                    <!-- <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="premium">داستان پولی</label>
                      <fv-switch
                        id="premium"
                        class="form-control d-block"
                        placeholder="پولی"
                        v-model="item.premium_required"
                      />
                    </div>
                  </div> -->
                  </div>

                  <div class="clearfix" />
                </div>
              </card>
            </div>
            <!-- <div v-if="item.premium_required" class="col-12">
            <card class="card" title="درصد هرکدام از سازنده‌های داستان">
              <div>
                <fvTable
                  class="fv-size-lg"
                  v-if="creators.length"
                  :fields="fields"
                  :rows="creators"
                >
                  <template slot="field-#" slot-scope="scope">
                    <span>{{ scope.index + 1 }}</span>
                  </template>
                  <template slot="field-نام" slot-scope="scope">
                    {{ scope.row.name || "" }} {{ scope.row.family_name || "" }}
                  </template>
                  <template slot="field-نقش" slot-scope="scope">
                    <div>
                      {{
                        scope.row.roleInStroy.map(
                          (val) =>
                            $store.state.main.usersRoles.find(
                              (fVal) => fVal.value === val
                            ).text
                        ) + ""
                      }}
                    </div>
                  </template>
                  <template slot="field-سهم" slot-scope="scope">
                    <div class="form-group text-right">
                      <label :for="`share${scope.index}`"></label>
                      <input
                        :id="`share${scope.index}`"
                        pattern="\d*"
                        maxlength="3"
                        type="text"
                        class="form-control"
                        placeholder="سهم"
                        @input="updatePercentage(scope.row, $event)"
                        :value="
                          item.shares.some(
                            (val) => val.account_id === scope.row.id
                          )
                            ? item.shares.find(
                                (val) => val.account_id === scope.row.id
                              ).percentage
                            : 0
                        "
                      />
                    </div>
                  </template>
                </fvTable>

                <div class="clearfix" />
              </div>
            </card>
          </div> -->
            <!-- <div class="col-12">
            <card class="card" title="مدیا">
              <div>
                <div class="form-row">
                  <div class="col-12">
                    <div class="form-group text-right">
                      <label for="media">فایل صوتی</label>
                      <appFileUploader2
                        id="media"
                        v-model="item.media"
                        :type="['MP3', 'AMR', 'MPEG']"
                        :multiple="true"
                      />
                      <form>
                        <input
                          type="file"
                          id="audioFile"
                          name="audio"
                          @change="uploadAudio"
                        />
                      </form>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group text-right">
                      <label for="gallery">عکس </label>
                      <form>
                        <input
                          type="file"
                          id="myFile"
                          name="filename"
                          @change="upload"
                        />
                      </form>
                      <!-- <appImageUploader2 /> -->
            <!-- id="gallery" -->
            <!-- v-model="item.gallery" -->
            <!-- :multiple="true" -->
            <!-- </div>
                  </div> -->

            <!-- <div class="col-12">
                    <div class="form-group text-right">
                      <label for="banner">تریلر</label>
                      <form>
                        <input
                          type="file"
                          id="trailer"
                          name="trail"
                          @change="uploadTrailer"
                        />
                      </form> -->
            <!-- <AppTrailerUploader
                        id="media"
                        v-model="item.media"
                        :type="['MP3', 'AMR', 'MPEG']"
                        :multiple="true"
                      /> -->
            <!-- </div>
                  </div> -->
            <!-- 
                  <div class="col-12">
                    <div class="form-group text-right">
                      <label for="video">ویدیو</label>
                      <appFileUploader
                        id="video"
                        v-model="item.videos"
                        :multiple="true"
                        :type="['VIDEO']"
                      />
                    </div>
                  </div> -->
            <!-- <div class="col-12">
                    <div class="form-group text-right">
                      <label for="color">رنگ پیش زمینه</label>
                      <appColorPicker
                        id="color"
                        v-model="item.background_color"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div> -->
            <!-- <div class="col-12">
            <card class="card" title="افراد">
              <div>
                <div class="form-row">
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="writers">کارکتر(ها)</label>
                      <appUserSelect
                        selectByType
                        id="writers"
                        placeholder="کارکتر(ها)"
                        type="CHARACTER"
                        v-model="item.character_ids"
                        :multiple="true"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="writers">نویسنده(گان)</label>
                      <appUserSelect
                        id="writers"
                        placeholder="نویسندگان"
                        type="author"
                        v-model="item.author_ids"
                        @data=""
                        :multiple="true"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="narrators">راویان</label>
                      <appUserSelect
                        id="narrators"
                        placeholder="راویان"
                        type="narrator"
                        v-model="item.narrator_ids"
                        :multiple="true"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="illustrator">تصویرگر(ان)</label>
                      <appUserSelect
                        id="illustrator"
                        placeholder="تصویرگر(ان)"
                        type="illustrator"
                        v-model="item.illustrator_ids"
                        :multiple="true"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div> -->
            <div class="col-12">
              <card class="card" title="توضیحات">
                <div>
                  <div class="form-row">
                    <div class="col-12">
                      <div class="form-group text-right">
                        <label for="description">توضیحات(حداکثر 20 کلمه)</label>
                        <appTextEditor
                          v-model="item.description"
                          id="description"
                          placeholder="توضیحات"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-12">
              <div class="form-group text-right">
                <label for="gallery">گالری </label>
                <AppBookFileUploader3
                  id="gallery"
                  v-model="item.imageAddress"
                  :bookId="this.id"
                />
              </div>
              <p id="imageUrl"></p>
            </div>

            <!-- <div class="col-12">
            <card class="card" title="خلاصه داستان">
              <div>
                <div class="form-row">
                  <div class="col-12">
                    <div class="form-group text-right">
                      <label for="synopsis">خلاصه داستان</label>
                      <appTextEditor
                        v-model="item.synopsis"
                        id="synopsis"
                        placeholder="خلاصه داستان"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div> -->
            <!-- <div class="col-12">
            <card class="card" title="تاریخ نمایش">
              <div>
                <div class="form-row">
                  <div
                    class="col-12 col-lg-4 mb-3"
                    v-for="(val, i) in item.for_days"
                  >
                    <div class="form-group text-right d-flex flex-wrap">
                      <label class="w-100" :for="'for_days' + i">زمان</label>
                      <appDatePicker
                        id="publish_date"
                        placeholder="زمان"
                        v-model="item.for_days[i]"
                        :multiple="true"
                      />
                      <button
                        @click.prevent="item.for_days.splice(index, 1)"
                        class="btn btn-outline-danger mr-2"
                      >
                        پاک کردن
                        <i class="fa fa-trash" />
                      </button>
                    </div>
                  </div>
                  <div class="col-12 mt-3">
                    <button
                      @click.prevent="item.for_days.push('')"
                      class="btn btn-outline-primary"
                    >
                      اضافه کردن
                      <i class="fas fa-plus" />
                    </button>
                  </div>
                </div>
              </div>
            </card>
          </div> -->
          </div>
        </div>
      </div>
    </form>
    <hr />
    <div class="row">
      <!-- <div v-if="(isEditing = false)">
        <button class="btn btn-warning">
          ویرایش اطلاعات قسمت ها
        </button>
      </div>
      <div v-else>
        <button class="btn btn-success">ثبت اطلاعات جدید</button>
      </div> -->

      <!-- <section class="col-12" v-if="id !== 'new'">
        <chaptersDetails :bookId="this.id" :book="this.book" />
      </section> -->

      <h3 class="mb-2 text-center" v-if="chapters.length">قسمت ها</h3>
      <h3 class="mb-2 text-center" v-else>این کتاب هیچ قسمتی ندارد.</h3>
      <p class="ImageURL2"></p>
      <div class="col-12" v-for="chapter in chapters" :key="chapter.id">
        <div>
          <button class="btn btn-success ml-2" @click="editChapter">
            <i class="fa fa-edit"></i> ثبت تغییرات
          </button>
          <button
            class="btn btn-danger"
            @click="deleteChapter(chapter.chapterId)"
          >
            <i class="fa fa-trash"></i> حذف
          </button>
        </div>
        <div class="col-12 col-lg-4 mb-3">
          <div class="form-group text-right">
            <label for="title">عنوان</label>
            <input
              id="title"
              type="text"
              class="form-control"
              placeholder="عنوان"
              v-model="chapter.bookName"
            />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group text-right">
            <label for="media">فایل صوتی </label>
            <AppBookFileUploader id="media" />
          </div>
          <p id="imageUrl2"></p>
        </div>
      </div>
    </div>
    <div class="col-12 mt-3" v-if="id !== 'new'">
      <button
        class="btn btn-success mr-2"
        @click="$router.push({ name: 'addChapter', params: { id } })"
      >
        <span>
          <i class="fas fa-plus">اضافه کردن قسمت جدید</i>
        </span>
      </button>
    </div>
  </div>
</template>
<script>
import Modela from "modela";
import { mapActions } from "vuex";
import bookModel from "../../models/books";
import { API_URL2 } from "../../env";
import UserCard from "../UserProfile/UserCard.vue";
import MembersCard from "../UserProfile/MembersCard.vue";
import appDatePicker from "../../components/appDatePicker";
import appFileUploader from "../../components/appFileUploader";
import appUserSelect from "../../components/appUserSelect";
import appCategorySelect from "../../components/appCategorySelect";
import appGendersSelect from "../../components/appGendersSelect";
import appTextEditor from "../../components/appTextEditor";
import appColorPicker from "../../components/appColorPicker";
import { StatsCard } from "@/components/index";
import versionModel from "../../models/versions";
import AppFileUploader from "../../components/appFileUploader.vue";
import AppFileUploader2 from "../../components/appFileUploader3.vue";
import AppImageUploader2 from "../../components/appImageUploader2.vue";
import AppTrailerUploader from "../../components/appTrailerUploader.vue";
import axios from "axios";
import Vue from "vue";
import Button from "../../components/Button.vue";
import chaptersDetails from "./chaptersDetails.vue";
import AppBookFileUploader from "../../components/appBookFileUploader.vue";
import AppBookFileUploader3 from "../../components/appFileUploader3.vue";
// import appRepeatable from "../../components/appRepeatable";
export default {
  name: "story_edit",
  components: {
    AppBookFileUploader3,
    AppBookFileUploader,
    StatsCard,
    chaptersDetails,
    UserCard,
    MembersCard,
    appFileUploader,
    appDatePicker,
    appUserSelect,
    appCategorySelect,
    appGendersSelect,
    appTextEditor,
    appColorPicker,
    AppFileUploader,
    AppFileUploader2,
    AppImageUploader2,
    AppTrailerUploader,
    Button,
    // appRepeatable
    AppBookFileUploader
  },
  data() {
    const { params } = this.$route;
    const { id } = params;
    return {
      ...mapActions("main", ["crud"]),
      id,
      item: {},
      creators: [],
      chapters: [],
      baseUrl: API_URL2,
      book: {},
      fields: ["#", "نام کتاب", "نام فصل", "تاریخ ثبت", "actions"],
      isEditing: false
    };
  },
  computed: {},
  methods: {
    async getData() {
      console.log("helloooo");
      // try {
      const token = Vue.$cookies.get("accessToken");
      console.log("tokeeen", token);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Accept", "*");
      myHeaders.append("Authorization", "Bearer " + token);

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
      };

      await fetch(`${this.baseUrl}/panel/book/id/${this.id}`, requestOptions)
        .then(response => response.text())
        .then(result => {
          const story = JSON.parse(result);
          console.log("story", story);
          if (story) {
            console.log("story.data", story);
            this.chapters = story.chapters;
            console.log("chapters", this.chapters);
            const result = story;
            const book = story;
            this.book = book;
            let item = new Modela(bookModel);
            item = item.$clean();
            item = item.$set(result);
            this.item = item.$clean().$export();
            console.log("this.item", this.item);

            const creatorsResult = [];
            this.creators.forEach(function(a) {
              if (!this[a.id]) {
                this[a.id] = a;
                creatorsResult.push(this[a.id]);
              } else {
                this[a.id].roleInStroy.push(a.roleInStroy[0]);
              }
            }, Object.create(null));
            this.creators = creatorsResult;
          }
          this.$store.commit("main/SET", { key: "loading", value: false });
        })
        .catch(error => console.log("error", error));

      // if (story.data) {
      //   console.log("story.data", story.data);
      //   this.chapters = story.data.chapters;
      //   console.log("chapters", this.chapters);
      //   const result = story.data;
      //   const book = story.data;
      //   this.book = book;
      //   let item = new Modela(bookModel);
      //   item = item.$clean();
      //   item = item.$set(result);
      //   this.item = item.$clean().$export();
      //   console.log("this.item", this.item);

      //   const creatorsResult = [];
      //   creators.forEach(function(a) {
      //     if (!this[a.id]) {
      //       this[a.id] = a;
      //       creatorsResult.push(this[a.id]);
      //     } else {
      //       this[a.id].roleInStroy.push(a.roleInStroy[0]);
      //     }
      //   }, Object.create(null));
      //   this.creators = creatorsResult;
      // }
      // const authors = item.authors.map(val => {
      //   val.roleInStroy = ["author"];
      //   return val;
      // });
      // const illustrators = item.illustrators.map(val => {
      //   val.roleInStroy = ["illustrator"];
      //   return val;
      // });
      // const narrators = item.narrators.map(val => {
      //   val.roleInStroy = ["narrator"];
      //   return val;
      // });
      // const creators = [...authors, ...illustrators, ...narrators];
      // } catch (e) {
      //   console.log(e);
      // } finally {
      //   this.$store.commit("main/SET", { key: "loading", value: false });
      // }
    },
    async deleteChapter(chapterId) {
      try {
        const token = Vue.$cookies.get("accessToken");
        console.log("deleted ID", chapterId);
        const bookId = this.id;
        console.log("fucking bookId", bookId);
        const result = await axios.delete(
          `${this.baseUrl}/panel/chapter/book/set/${bookId}/${chapterId}`,
          {
            headers: {
              Authorization: "Bearer " + token
            }
          }
        );
        console.log("deleted", result);
      } catch (error) {
        console.log(error);
      }
    },
    async editChapter() {
      console.log("edited");
    },

    async upload() {
      let photo = document.getElementById("myFile").files[0];
      let formData = new FormData();
      formData.append("file", photo);
      const token = Vue.$cookies.get("accessToken");
      axios.post(`${this.baseUrl}/panel/book/image/upload‍‍`, formData, {
        headers: {
          Authorization: "Bearer " + token
        }
      });
    },
    async uploadAudio() {
      // console.log("upload")
      let audio = document.getElementById("audioFile").files[0];
      let formData = new FormData();
      formData.append("file", audio);
      const token = Vue.$cookies.get("accessToken");
      axios.post(
        "https://dev.api.ighe3.com/v5/panel/book/file/upload",
        formData,
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      );
    },
    async uploadTrailer() {
      let trailer = document.getElementById("trailer").files[0];
      console.log(trailer);
      let formData = new FormData();
      formData.append("file", trailer);
      const token = Vue.$cookies.get("accessToken");
      console.log("token", token);
      axios.post(
        "https://dev.api.ighe3.com/v5/panel/book/trailer/upload",
        formData,
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      );
    },
    // https://dev.api.ighe3.com/v5/panel/book/set
    async post() {
      try {
        const imageUrl = document.getElementById("imageUrl").innerHTML;
        this.item.imageAddress = imageUrl || null;
        const token = Vue.$cookies.get("accessToken");
        console.log("item", this.item);
        const res = await axios.post(
          `${this.baseUrl}/dashboard/book/1`,
          this.item,
          {
            headers: {
              Authorization: "Bearer " + token
            }
          }
        );
        await console.log("res", res);
        // const newStory = await this.crud({
        //   action: "post",
        //   section: "stories",
        //   data: this.item,
        //   showError: true,
        // });
        this.$successAlert();
        this.$router.go(-1);
        await this.$router.push({ name: "books" });
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },
    // async deleteChapter(chapterId) {
    //   try {
    //     const token = Vue.$cookies.get("accessToken");
    //     console.log("deleted ID", chapterId);
    //     const bookId = this.id;
    //     console.log("fucking bookId", bookId);
    //     const result = await axios.delete(
    //       `https://dev.api.ighe3.com/v5/panel/chapter/book/set/${bookId}/${chapterId}`,
    //       {
    //         headers: {
    //           Authorization: "Bearer " + token
    //         }
    //       }
    //     );
    //     console.log("deleted", result);
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    async deleteBook() {
      try {
        const bookId = this.id;
        const token = Vue.$cookies.get("accessToken");
        const result = await axios.delete(
          `${this.baseUrl}/v5/panel/book/set/${bookId}`,
          {
            headers: {
              Authorization: "Bearer " + token
            }
          }
        );
        this.$successAlert();
        this.$router.go(-1);
        await this.$router.push({ name: "books" });
        console.log("book Deleted", result);
      } catch (error) {
        console.log(error);
      }
    },
    async put() {
      try {
        const token = Vue.$cookies.get("accessToken");
        const result = await axios.put(
          `${this.baseUrl}/panel/book/set/${this.id}`,
          {
            title: this.item.title,
            price: this.item.price,
            euroPrice: this.item.euroPrice,
            description: this.item.description,
            authors: this.item.authors,
            narrators: this.item.narrators,
            publication: this.item.publication,
            illustrators: this.item.illustrators,
            enable: this.item.enable
          },
          {
            headers: {
              Authorization: "Bearer " + token
            }
          }
        );
        this.$successAlert();
        this.$router.go(-1);
        await this.$router.push({ name: "books" });
        // await this.$router.push({name: 'stories'})
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },
    async del() {
      if (!(await this.$confirmAlert())) return false;
      try {
        this.$store.commit("main/SET", { key: "loading", value: true });
        const deleted = await this.crud({
          action: "delete",
          section: "stories",
          id: this.id,
          showError: true
        });
        await this.$successAlert();
        this.$router.go(-1);
        // await this.$router.push({name: 'stories'})
      } catch (e) {
        // console.log(e)
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },
    async submit() {
      if (this.id !== "new") this.put();
      else this.post();
    },
    updatePercentage(item, event) {
      const value = parseFloat(event.target.value);
      if (!value && value !== 0) return;

      if (this.item.shares.some(val => val.account_id === item.id))
        this.item.shares = this.item.shares.map(val => {
          if (val.account_id === item.id) {
            val.percentage = value;
          }
          return val;
        });
      else this.item.shares.push({ account_id: item.id, percentage: value });
    }
  },
  async created() {
    console.log("single book page");
    setInterval(() => {
      console.log("set interval");
    }, 2000);
    if (this.id !== "new") await this.getData();
    else {
      let item = new Modela(bookModel);
      this.item = item.$clean().$export();
      console.log("this item", this.item);
    }
  }
};
</script>
<style></style>
